var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000002493(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#EAEAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10723 8.74102C4.55142 9.17313 5.48624 10.1296 6.21066 11.1897C6.356 11.4025 6.67247 11.3945 6.80787 11.1753C7.61547 9.86798 9.92992 6.27267 11.827 4.7984C12.0175 4.65042 12.0569 4.3785 11.9141 4.18408L11.9124 4.18195C11.7639 3.97998 11.4783 3.93984 11.28 4.09336C10.358 4.80696 7.88412 6.77965 6.24766 8.62865L4.44484 8.14608C4.32115 8.11298 4.18927 8.14935 4.09993 8.24121C3.96391 8.38126 3.9673 8.60487 4.10723 8.74102Z",
    fill: "#01017C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002493);
export default __webpack_public_path__ + "static/media/Group-1000002493.927c337cc7438150f0de27bf486ddc28.svg";
export { ForwardRef as ReactComponent };